import { Component, Input } from '@angular/core';
import { Menu } from '../../services/site.model';

@Component({
    selector: 'layout',
    templateUrl: './layout.component.html'
})
export class LayoutComponent {
    @Input() menus: Menu[] = [];
    
    ngOnInit() {
    }
}
